module.exports = __webpack_public_path__ + "images/sort-down-hover-red-bf4caa28.svg";